import React, { useEffect, useState } from 'react'
import { Card, CardBody } from '../other/card/card';
import Chart from 'react-apexcharts';
import generateStats from './data/stats';
import { useGetReportedRemovedQuery, useGetCampaignOverviewQuery } from '../../redux/apis/analyticsManagement/aMAnalyticsApiSlice';
import ComponentLoader from '../other/ComponentLoader';

const AnalyticsBox = ({ campaignId } = {}) => {
    const params = campaignId ? { campaign_id: campaignId } : undefined;
    const { data, isFetching } = useGetReportedRemovedQuery(params);
    const { data: campaignOverview } = useGetCampaignOverviewQuery(params, { skip: !!campaignId });

    const [statsData, setStatsData] = useState();
    const [chartOptions, setChartOptions] = useState(getChartOptions());

    function getChartOptions() {
        var themeColor = (getComputedStyle(document.body).getPropertyValue('--bs-theme')).trim();
        var themeColorRgb = (getComputedStyle(document.body).getPropertyValue('--bs-theme-rgb')).trim();

        return {
            bar: {
                colors: [themeColor],
                chart: { sparkline: { enabled: true } },
                tooltip: { enabled: false, x: { show: false }, y: { title: { formatter: function () { return '' } } } },
                dataLabels: { enabled: false },
                events: { mouseMove: function () { return false; } }
            },
            line: {
                colors: [themeColor],
                chart: { sparkline: { enabled: true } },
                stroke: { curve: 'straight', width: 2 },
                tooltip: { enabled: false, x: { show: false }, y: { title: { formatter: function () { return '' } } } },
                dataLabels: { enabled: false },
                events: { mouseMove: function () { return false; } }
            },
            pie: {
                colors: ['rgba(' + themeColorRgb + ', 1)', 'rgba(' + themeColorRgb + ', .75)', 'rgba(' + themeColorRgb + ', .5)'],
                chart: { sparkline: { enabled: true } },
                stroke: { show: false },
                tooltip: { enabled: false, x: { show: false }, y: { title: { formatter: function () { return '' } } } },
                dataLabels: { enabled: false },
                events: { mouseMove: function () { return false; } }
            },
            donut: {
                colors: ['rgba(' + themeColorRgb + ', .15)', 'rgba(' + themeColorRgb + ', .35)', 'rgba(' + themeColorRgb + ', .55)', 'rgba(' + themeColorRgb + ', .75)', 'rgba(' + themeColorRgb + ', .95)'],
                chart: { sparkline: { enabled: true } },
                stroke: { show: false },
                tooltip: { enabled: false, x: { show: false }, y: { title: { formatter: function () { return '' } } } },
                dataLabels: { enabled: false },
                events: { mouseMove: function () { return false; } }
            }
        };
    }

    useEffect(() => {
        const all = generateStats(campaignOverview, data);
        setStatsData(campaignId ? all.slice(2) : all)
        document.addEventListener('theme-reload', () => {
            setChartOptions(getChartOptions());
        });
        // eslint-disable-next-line
    }, [data, campaignOverview]);

    return (
        <div className='flex justify-between gap-2'>
            {statsData && statsData.length > 0 && statsData.map((stat, index) => (
                <div className="flex-grow" key={index}>
                    <Card className="mb-3">
                        <CardBody className="relative p-0">
                            {isFetching ? <ComponentLoader /> : null}
                            <div className='p-4'>
                                <div className="d-flex fw-bold small mb-3">
                                    <span className="flex-grow-1">{stat?.title}</span>
                                </div>
                                <div className="row align-items-center mb-2">
                                    <div className="col-7">
                                        <h4 className="mb-0">{stat?.total}</h4>
                                    </div>
                                    <div className="col-2">
                                        <div className="mt-n3">
                                            <Chart type={stat?.chartType} height={stat?.chartHeight} options={chartOptions[stat?.chartType]} series={stat?.chartData} />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </CardBody>
                    </Card>
                </div>
            ))}
        </div>
    )
}

export default AnalyticsBox
